// Making a new JS component
// 1 - Replace footer with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var footer = {
    name: "footer",
    componentInitSelector: "footer",
    registerComponent: function () {
        if ($(footer.componentInitSelector).length) {
            framework.registerComponent(footer);
        }
    },
    initcomponentTemplate: function () {
        // Put your args and inits here with their options.
        // End
        // log(
        //     config.application.name +
        //         " •• footer in " +
        //         Math.round(
        //             performance.now() -
        //                 framework.initComponents.componentInitTime
        //         ) +
        //         " milliseconds"
        // );
    },
    init: function () {
        // All code for this component goes in here

        // End
        footer.initcomponentTemplate();
    },
};

// Register self to the framework
footer.registerComponent();
